import './NoObjectsAlert.scss';
import { AsyncStateNotification } from '@ui/notifications';
import { Button } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { ErrorOrFailStatusCode } from '@sonar-software/sonar-http';
import { FullUserBoundary } from '@ui/general';
import { SonarAlert } from '@ui/SonarAlert';
import { SonarText } from '@ui/text';
import { useAction } from '@hooks';
import { useNavigate } from 'react-router';
import { CHANGE_EVENT_PREFERENCES, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
const postDataSecurityMonitoredObjectsSelectors = createAsyncSelectors((state) => state.core.dataSecurity.monitoredObjects.post);
export const NoObjectsAlert = ({ failed, onRefresh }) => {
    const postMonitoredObjects = useAction(coreActions.requestPostCoreDataSecurityMonitoredObjects);
    const navigate = useNavigate();
    const handleUseSuggestedClick = useCallback(() => {
        postMonitoredObjects();
    }, [postMonitoredObjects]);
    const handleReauthenticateClick = useCallback(() => {
        navigate(FULL_ROUTES.SETTINGS_ORGANIZATION);
    }, [navigate]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SonarAlert, { active: true, closable: !failed, message: failed ?
                React.createElement("div", { className: 'no-objects-message' },
                    React.createElement(SonarText, null, CHANGE_EVENT_PREFERENCES.SALESFORCE_CREDENTIALS_EXPIRED),
                    React.createElement(FullUserBoundary, null,
                        React.createElement(Button, { className: 'suggested-objects-button', onClick: handleReauthenticateClick, type: 'primary' }, CHANGE_EVENT_PREFERENCES.REAUTHENTICATE))) :
                React.createElement("div", { className: 'no-objects-message' },
                    React.createElement(SonarText, null, CHANGE_EVENT_PREFERENCES.NO_OBJECTS_SELECTED),
                    React.createElement(FullUserBoundary, null,
                        React.createElement(Button, { className: 'suggested-objects-button', onClick: handleUseSuggestedClick, type: 'primary' }, CHANGE_EVENT_PREFERENCES.USE_SUGGESTED_OBJECTS))), showIcon: true, type: 'warning' }),
        React.createElement(AsyncStateNotification, { byStatusCode: [
                {
                    options: {
                        description: CHANGE_EVENT_PREFERENCES.SELECT_SUGGESTED_OBJECTS_ERROR,
                        options: { message: CHANGE_EVENT_PREFERENCES.OBJECTS_ALREADY_SELECTED }
                    },
                    statusCode: ErrorOrFailStatusCode.Conflict
                }
            ], resetAction: onRefresh, stateSelector: postDataSecurityMonitoredObjectsSelectors.state })));
};
